export default __webpack_public_path__ + "static/media/banner1.8c971b5b.jpg";